import { Backdrop, Box, Button, Card, CardContent, CircularProgress, Container, Divider, Grid, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useFormik, Form, FormikProvider, getIn } from "formik";
import * as Yup from 'yup';
import FormFileField from '../../../components/form/formFileField';
import FormField from '../../../components/form/formField';
import bankServices from '../../../services/bankServices';
import FormSelect from '../../../components/form/formSelect';
import CustomDropZoneDoc from '../../../components/customDropZoneDoc';
import AreYouHufHead from '../../../components/modals/HufHeadAndTrust';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import userServices from '../../../services/userServices';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import logsService from '../../../services/logServices';
import { InvestorActivityEventType } from '../../../utils/eventTypes';

import { sanitizeIfscInput } from "../../../utils/kycSanitizers";
import { sanitizePanInput } from "../../../utils/kycSanitizers";
import { sanitizeAccountNumberInput } from "../../../utils/kycSanitizers";
import { sanitizeNameInput } from "../../../utils/kycSanitizers";
const VALID_FILE_SIZE = 5 * 1024 * 1024;
const SUPPORTED_FORMATS = ["image/png", "image/jpeg","image/webp"];
const ACCEPTED_IMAGE_FORMATS = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
};
const SUPPORTED_FORMATS_PDF = ['application/pdf']
const ACCEPTED_PDF_FORMATS = {
  "application/pdf": [".pdf"],
};

const hufKycSchema = Yup.object().shape({
  legalName: Yup.string()
    .required("Name is required.")
    .matches(/^[a-zA-Z\s.']+$/, "Enter a valid name")
      .min(3, "Legal Name must be at least 3 characters")
    .max(50, "Legal Name must not exceed 50 characters"),
  panCardNumber: Yup.string().matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Invalid PAN number format")
    .length(10, "Pan No. must be exactly 10 characters").required("PAN No. is required."),
  bankInformation: Yup.object().shape({
      ifsc: Yup.string()
                .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC format (11 characters: 4 letters, 0, then 6 alphanumeric)")
                .required("IFSC code is required."),
    accHolderName: Yup.string().required("Name is required."),

    //accountNumber: Yup.number().required("Account Number is required."),
      accountNumber: Yup.string()
            .matches(/^[0-9]{9,16}$/, "Account number must be 9 to 16 digits")
            .required("Account Number is required."),
    accountType: Yup.string().required("Account Type is required."),
  }), 


  panCard: Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "Upload a file below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
    .test("fileFormat",
      "Only JPEG and PNG files are allowed",
      (value) => !value || (value instanceof File && SUPPORTED_FORMATS.includes(value.type))),
  bankCheque: Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "Upload a file below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
    .test("fileFormat",
      "Only JPEG and PNG files are allowed",
      (value) => !value || (value instanceof File && SUPPORTED_FORMATS.includes(value.type))),
  hufDeed: Yup.mixed().nullable().required("Document Is Required").test("FILE_SIZE", "Uploaded file is too big.", value => value && value.size <= 4024 * 4024).test("fileFormat",
    "Only PDF files are allowed",
    (value) => !value || (value instanceof File && SUPPORTED_FORMATS_PDF.includes(value.type))),
})

const hufUpdateSchema = Yup.object().shape({
  panCardNumber: Yup.string().matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Invalid PAN number format")
    .length(10, "Pan No. must be exactly 10 characters").required("PAN No. is required."),
  bankInformation: Yup.object().shape({
      ifsc: Yup.string()
                .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC format (11 characters: 4 letters, 0, then 6 alphanumeric)")
                .required("IFSC code is required."),

    accHolderName: Yup.string().required("Name is required."),
    accountNumber: Yup.string()
            .matches(/^[0-9]{9,16}$/, "Account number must be 9 to 16 digits")
            .required("Account Number is required."),
    accountType: Yup.string().required("Account Type is required."),
  }),
})

export default function HufRegistration() {

  const [panSelectedImage, setPanSelectedImage] = useState(null);
  const [checkImage, setCheckImage] = useState(null);
  const [showBranch, setShowBranch] = useState("");
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const user = useSelector(state => state.user.data);
  const { hufData, url, mode } = state || {};
  const [openProgressBar, setOpenProgressBar] = useState(false);

  useEffect(() => {
    if (hufData && Object.keys(hufData).length > 0) {
      setPanSelectedImage(url + hufData?.huf?.documents?.find(doc => doc.docName === "Pan Card")?.docUrl);
      setCheckImage(url + hufData?.huf?.documents?.find(doc => doc.docName === "Bank Cheque")?.docUrl);
    }
  }, [hufData]);

  let bankAccount
  if(hufData?.bankAccount?.length>0){
    bankAccount = hufData?.bankAccount[0] || {};
  }
  const formik = useFormik({
    initialValues: {
      legalName: hufData?.huf?.legalName || "",
      panCardNumber: hufData?.huf?.panCardNumber || "",
      panCard: hufData?.huf?.documents?.find(doc => doc.docName === "Pan Card")?.docUrl
        ? { name: hufData?.huf?.documents?.find(doc => doc.docName === "Pan Card").docUrl }
        : null,
      bankCheque: hufData?.huf?.documents?.find(doc => doc.docName === "Bank Cheque")?.docUrl
        ? { name: hufData?.huf?.documents?.find(doc => doc.docName === "Bank Cheque").docUrl }
        : null,
      bankInformation: {
        ifsc: bankAccount?.ifsc || "",
        accHolderName: bankAccount?.accHolderName || "",
        accountNumber: bankAccount?.accountNumber || "",
        bankName: bankAccount?.bankName || "",
        accountType: bankAccount?.accountType || "",
      },
      hufDeed: hufData?.huf?.documents?.find(doc => doc.docName === "HUF deed")?.docUrl
        ? { name: hufData?.huf?.documents?.find(doc => doc.docName === "HUF deed").docUrl }
        : null,
    },
    validationSchema: hufData?.huf ? hufUpdateSchema : hufKycSchema,
    onSubmit: (data) => {
      if (mode === "edit") {
        const editedFields = Object.keys(data).reduce((acc, key) => {
          // Compare file fields by name (URL or new file) instead of entire object
          if (
            (key === "panCard" && data[key]?.name !== formik.initialValues[key]?.name) ||
            (key === "bankCheque" && data[key]?.name !== formik.initialValues[key]?.name) ||
            (key === "hufDeed" && data[key]?.name !== formik.initialValues[key]?.name) ||
            (key !== "panCard" && key !== "bankCheque" && key !== "hufDeed" && data[key] !== formik.initialValues[key])
          ) {
            acc[key] = data[key];
          }
          return acc;
        }, {});
        handleUpdateHufKyc(editedFields);
      } else {
        handleHufKyc(data);
      }
    },
  });

  const { errors, touched, handleSubmit, getFieldProps, values, setFieldValue, setFieldError, handleBlur, isSubmitting, setSubmitting, submitForm } = formik;

  const accTypeOptions = [
    {
      title: "HUF Current account",
      value: "Current account",
    },
    {
      title: "HUF Saving account",
      value: "Saving account",
    },
  ]

  const handleHufKyc = async (data) => {
    const formData = new FormData();
    Object.keys((data)).map((key) => formData.append(key, data[key]));
    formData.delete('bankInformation');
    formData.append('bankInformation', JSON.stringify(data.bankInformation));
    formData.append("investorId", user._id);
    formData.append("isHead", true);
    formData.append("status", "KYC_COMPLETE")
    setSubmitting(true);
    setOpenProgressBar(true);
    const res = await userServices.createHuf(formData);
    console.log(res)
    if (res && res.success) {
      setSubmitting(false);
      setOpenProgressBar(false);
      navigate('/dashboard/profile?tab=1');
      enqueueSnackbar("HUF details submitted", {
        variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" },
        autoHideDuration: 3000,
      });
      logsService.addLog({
        userId: user?._id,
        event: InvestorActivityEventType.HUF_REGISTRATION_SUBMITTED
      })
    }
    else {
      setSubmitting(false);
      setOpenProgressBar(false);
      enqueueSnackbar(res?.response?.data?.error || res?.response?.data?.message || res?.message || "Somthing went wrong!", {
        variant: "error",
        anchorOrigin: { horizontal: "right", vertical: "top" },
        autoHideDuration: 3000,
      });
    }
  }

  const handleUpdateHufKyc = async (data) => {
    const formData = new FormData();
    Object.keys(data).map((key) => formData.append(key, data[key]));
    formData.delete('bankInformation');
    formData.append('bankInformation', JSON.stringify(data.bankInformation));
    formData.append('investorId', user._id);
    formData.append("status", "KYC_COMPLETE");
    setSubmitting(true);
    setOpenProgressBar(true);
    const res = await userServices.updateHufDetails(hufData.huf._id, formData);
    if (res && res.success) {
      setSubmitting(false);
      setOpenProgressBar(false);
      navigate('/dashboard/profile?tab=1');
      enqueueSnackbar('HUF details updated successfully', {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        autoHideDuration: 3000,
      });
    } else {
      setSubmitting(false);
      setOpenProgressBar(false);
      enqueueSnackbar(res?.error, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        autoHideDuration: 3000,
      });
    }
  };


  const getBankFromIFSC = async (ifscCode) => {
    const ifsc = ifscCode || values?.bankInformation?.ifsc;
    if (!ifsc) return;

    const res = await bankServices.getBankFromIFSCCode(ifsc);
    const bankName = typeof res === "object" && res !== null ? res.BANK : null;
    const branch = typeof res === "object" && res !== null ? res.BRANCH : null;

    if (bankName && branch) {
      setShowBranch(`${bankName}, ${branch}`);
      setFieldValue("bankInformation.bankName", bankName);
      setFieldValue("bankInformation.branch", branch);
    } else {
      setShowBranch("");
      setFieldValue("bankInformation.bankName", "", false);
      setFieldValue("bankInformation.branch", "", false);
      setFieldError("bankInformation.ifsc", "IFSC Code Not Found");
    }
  }


  const handleImageChange = (file, type) => {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        // Set the selected image to the uploaded image
        if (type === "checkImage") {
          setCheckImage(e.target.result);
        } else if (type === "panImage") {
          setPanSelectedImage(e.target.result);
        }
      };

      reader.readAsDataURL(file);
    } else {
      // If no file is selected, clear the selected image
      // setFrontSelectedImage(null);
    }
  };



  return (
    <Container>
      <Backdrop open={openProgressBar} sx={{ color: "#ddd", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: (theme) => theme.zIndex.modal + 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress
                        size={75}
                        thickness={4}

                    />
                </Box>
            </Backdrop>
      <Card sx={{ mt: 5 }}>
        <CardContent>
          <Stack>
            <Box><Typography variant='mainCardTitle'>{mode === "edit" ? 'Update HUF Profile' : 'HUF Registration'}</Typography>
              <Divider
                sx={{
                  width: '100%',
                  mt: 1,
                }}
              />
            </Box>
            <Box>
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate >
                  <Stack rowGap={{ md: 1.5, xs: 1 }}>
                    <Stack sx={{ mx: '-5px', mt: { md: 2, xs: 1 } }}>
                      <Grid container columnGap={{ md: 3, xs: 0 }} rowGap={{ md: 3, xs: 2 }} boxShadow={{ md: 1 }} sx={{ borderRadius: '3px', px: { md: 3, xs: 0 }, py: { md: 3, xs: 1 } }}>
                        <Grid item xs={12} md={3.8}>



                          <FormField
                            label={"Enter Legal Name *"}
                            inputProps={{
                              placeholder: "Name",
                              ...getFieldProps("legalName"),
                                 onChange: (e) => {
                                 const sanitizedValue = sanitizeNameInput(e.target.value);
                                      setFieldValue("legalName", sanitizedValue);
                                   },
                              error: Boolean(
                                touched.legalName && errors.legalName
                              ),
                              helperText: touched.legalName && errors.legalName,
                            }}
                          />
                          </Grid>
                          <Grid item xs={12} ><Typography>Upload Your Documents (HUF)</Typography></Grid>
                          <Grid item xs={12} md={3.8}>


                              <FormFileField
                               label={"Upload PAN Card * (MAX 5MB only image)"}
                                   inputProps={{
                                   error: Boolean(touched.panCard && errors.panCard),
                                  helperText: touched.panCard && errors.panCard,
                                  value: values.panCard,
                                  accept: ACCEPTED_IMAGE_FORMATS,

                               maxSize: VALID_FILE_SIZE,
                              onChange: (file) => {
                              setFieldValue("panCard", file);
                              handleImageChange(file, "panImage");
                                },
                               }}
                            />                   

                            {panSelectedImage && (
                              <Box
                                style={{
                                  width: "auto",
                                  height: "130px",
                                  border: "1px solid rgb(183 183 183)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "6px",
                                  marginTop: "8px",
                                }}>

                                <img
                                  src={panSelectedImage}
                                  alt="Selected Image"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </Box>
                            )}
                          </Grid>

                          <Grid item xs={12} md={3.8}>
                            <FormField
                              label={"Enter PAN Card No (HUF) *"}
                              inputProps={{
                                placeholder: "Enter PAN Card No",
                                ...getFieldProps("panCardNumber"),
                                   inputProps: { maxLength: 10 },
                                    onChange: (e) => {
                                        setFieldValue("panCardNumber", sanitizePanInput(e.target.value));
                                    },
                                error: Boolean(
                                  touched.panCardNumber && errors.panCardNumber
                                ),
                                helperText: touched.panCardNumber && errors.panCardNumber,
                              }}
                            />
                          </Grid>
                          
                        </Grid>
                    </Stack>

                    <Stack sx={{ mx: '-5px' }}>
                      <Grid container columnGap={{ md: 3.2, xs: 0 }} rowGap={{ md: 3, xs: 2 }} boxShadow={{ md: 1 }} sx={{ borderRadius: '3px', px: { md: 3, xs: 0 }, py: { md: 3, xs: 1 } }}>
                        <Grid item xs={12} ><Typography>Enter Bank Details (HUF)</Typography></Grid>

                        <Grid item xs={12} md={3.8}>
                          <FormField
                            label={"Account Holder Name *"}
                            inputProps={{
                              ...getFieldProps("bankInformation.accHolderName"),

                                   onChange: (e) => {
                                   const sanitizedValue = sanitizeNameInput(e.target.value);
                                  setFieldValue(
                                 "bankInformation.accHolderName",
                                  sanitizedValue
                                 );
                                },

                              error: Boolean(
                                touched.bankInformation?.accHolderName &&
                                errors.bankInformation?.accHolderName
                              ),
                              helperText:
                                touched.bankInformation?.accHolderName &&
                                errors.bankInformation?.accHolderName,
                            }}
                          />
                        </Grid>
                       
                        <Grid item xs={12} md={3.8}>
                          <FormField
                            label={"IFSC CODE *"}
                            inputProps={{
                               placeholder: "Enter IFSC Code",
                              ...getFieldProps("bankInformation.ifsc"),

                           inputProps: { maxLength: 11, style: { textTransform: "uppercase" } },
                                      onChange: (e) => {
                                          setFieldValue(
                                              "bankInformation.ifsc",
                                              sanitizeIfscInput(e.target.value)
                                          );
                                      },
                              onBlur: (e) => { 
                                handleBlur(e);
                                getBankFromIFSC(e.target.value);
                              },
                              error: Boolean(
                                touched.bankInformation?.ifsc &&
                                (errors.bankInformation?.ifsc || errors.bankInformation?.bankName)
                              ),
                              helperText:
                                (touched.bankInformation?.ifsc &&
                                  (errors.bankInformation?.ifsc || errors.bankInformation?.bankName)) ||
                                showBranch,
                            }}
                          />
                        </Grid>
                        
                        <Grid item xs={12} md={3.8}>
                          <FormField
                            label={"Account Number *"}
                            inputProps={{
                               placeholder: "9-16 digits",
                              ...getFieldProps("bankInformation.accountNumber"),
                              inputProps: { inputMode: "numeric", maxLength: 16 },
                               onChange: (e) => {
                                          setFieldValue(
                                              "bankInformation.accountNumber",
                                              sanitizeAccountNumberInput(e.target.value)
                                          );
                                      },
                              error: Boolean(
                                touched.bankInformation?.accountNumber &&
                                errors.bankInformation?.accountNumber
                              ),
                              helperText:
                                (touched.bankInformation?.accountNumber &&
                                  errors.bankInformation?.accountNumber)
                            }}
                          />

                        </Grid>
                        <Grid item xs={12} md={3.8}>
                          <FormSelect
                            label={"Account Type *"}
                            options={accTypeOptions}
                            props={{
                              ...getFieldProps("bankInformation.accountType"),
                              error: Boolean(
                                touched.bankInformation?.accountType &&
                                errors.bankInformation?.accountType
                              ),
                              helperText:
                                (touched.bankInformation?.accountType &&
                                  errors.bankInformation?.accountType)
                            }}
                          />

                        </Grid>

                        <Grid item xs={12} md={3.8}>
                          <FormFileField
                            label={"Cancelled Cheque Image * (MAX 5MB only image)"}
                            inputProps={{
                              error: Boolean(touched.bankCheque && errors.bankCheque),
                              helperText: touched.bankCheque && errors.bankCheque,
                              value: values.bankCheque,
                                
                              accept: ACCEPTED_IMAGE_FORMATS,
                               maxSize: VALID_FILE_SIZE,
                              onChange: (file) => {
                                setFieldValue("bankCheque", file);
                                handleImageChange(file, "checkImage");
                              },
                            }}
                          />
                          {checkImage && (
                            <Box
                              style={{
                                width: "auto",
                                height: "130px",
                                border: "1px solid rgb(183 183 183)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "6px",
                                marginTop: "8px",
                              }}>

                              <img
                                src={checkImage}
                                alt="Selected Image"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    </Stack>
                    <Stack mx={'-5px'}>
                      <Grid container alignItems={'center'} columnGap={{ md: 3, xs: 0 }} rowGap={{ md: 3, xs: 2 }} boxShadow={{ md: 1 }} sx={{ borderRadius: '3px', px: { md: 3, xs: 0 }, py: { md: 3, xs: 1 } }}>
                        <Grid item xs={12} md={3.8}>
                          <Box>
                        

                            <CustomDropZoneDoc setter={(file) => { setFieldValue(`hufDeed`, file) }} title={'HUF Deed (max 5mb .only pdf) *'} errors={getIn(touched, `hufDeed`) &&
                              getIn(errors, `hufDeed`)} files={values?.hufDeed} edit={true}       
                              accept={ACCEPTED_PDF_FORMATS} maxSize={VALID_FILE_SIZE} />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={3.8}></Grid>
                      </Grid>

                    </Stack>

                  </Stack>
                  <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <LoadingButton
                      loading={isSubmitting}
                      onClick={() => submitForm()}
                      type="submit"
                      variant="contained"
                      sx={{ width: { xs: "auto" } }}
                      loadingIndicator={
                        <CircularProgress size={30} sx={{ color: 'red' }} />
                    }
                    >
                      {mode === "edit" ? 'Update' : 'Submit'}
                    </LoadingButton>
                    <Button
                      onClick={() => navigate('/dashboard/profile')}
                      variant="outlined"
                      sx={{ width: { xs: "auto" }, ml: 2 }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Form>
              </FormikProvider>
            </Box>
          </Stack>

        </CardContent>
      </Card>
    </Container>
  )
}